import { Badge } from "evergreen-ui";
import React from "react";
import styled from "styled-components";
import Button from "../Button";

const Container = styled.div`
  ${(props) => props.theme.whiteBox};
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  padding: 1rem;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

const Warnings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 1rem;
`;
const Title = styled.h1`
  color: ${(props) => props.theme.darkGreyColor};
  font-size: 1rem;
`;

const Subtitle = styled.h1`
  color: ${(props) => props.theme.primaryColor};
  font-size: 1.4rem;
  line-height: 1.6;
  font-weight: 700;
`;
const Footer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background-color: ${(props) => props.theme.extraLightGreyColor};
`;

const Description = styled.p`
  ${(props) => props.theme.darkGreyColor};
  font-size: 0.8rem;
`;

const ButtonHolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
const ButtonWrapper = styled.div``;

const BadgeWrapper = styled.div`
  padding: 0.125rem 0px;
`;
interface IProps {
  title: any | null | undefined;
  description?: any | null | undefined;
  subtitle: any | null | undefined;
  showButton: any | null;
  buttonLabel: any | null;
  buttonOnClick: any | null;
  buttonDisabled: boolean;
  hints?: undefined | object | any;
}
const BoxCard: React.SFC<IProps> = ({
  title,
  description,
  subtitle,
  showButton = null,
  buttonLabel = null,
  buttonOnClick = () => {},
  buttonDisabled = false,
  hints = undefined,
}) => {
  return (
    <Container>
      <Row>
        <Body>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </Body>
        {hints && (
          <Warnings>
            {hints.text ? (
              <Badge color={hints.color || "automatic"}>{hints.text}</Badge>
            ) : (
              hints.map((hint, index) => (
                <BadgeWrapper key={index}>
                  <Badge color={hint.color || "automatic"}>{hint.text}</Badge>
                </BadgeWrapper>
              ))
            )}
          </Warnings>
        )}
      </Row>
      <Footer>
        <Description>{description}</Description>
        {showButton && (
          <ButtonHolder>
            <ButtonWrapper>
              <Button
                label={buttonLabel}
                onClick={buttonOnClick}
                disabled={buttonDisabled}
              />
            </ButtonWrapper>
          </ButtonHolder>
        )}
      </Footer>
    </Container>
  );
};

export default BoxCard;
